export default class newsletterService {
  static async subscribeEmail(email) {
    const { $apiRequest } = useNuxtApp();
    const url = `/marketing/sendNewsletterUser`;
    const { data } = await $apiRequest.fetchPost(url, { email });
    return data;
  }
}
